import { render } from "./AgentiDetail.vue?vue&type=template&id=98edc016&scoped=true"
import script from "./AgentiDetail.vue?vue&type=script&lang=js"
export * from "./AgentiDetail.vue?vue&type=script&lang=js"

import "./AgentiDetail.vue?vue&type=style&index=0&id=98edc016&lang=css"
import "./AgentiDetail.vue?vue&type=style&index=1&id=98edc016&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98edc016"]])

export default __exports__